import React, { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Spinner,
  Button,
  Alert,
  Card,
} from "react-bootstrap";
import NavBar from "../../components/Heritage/NavigationBar";
import DOMPurify from "dompurify";
// import AppNavbar from "../../components/common/AppNavbar";

const FitnessDetails = () => {
  const { name } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const topicFromState = location.state?.topic;

  const [fitnessDetails, setFitnessDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sanitizedSteps, setSanitizedSteps] = useState("");

  useEffect(() => {
    const fetchDetails = async () => {
      try {
        const res = await fetch(
          "https://www.bharatabroad.com/api/ai/fitness-details",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ name }),
          }
        );

        if (!res.ok) throw new Error("Failed to fetch AI details");

        const data = await res.json();
        setFitnessDetails(data);

        // sanitize steps if HTML formatted
        const safeSteps = DOMPurify.sanitize(data.stepsHtml || "", {
          ALLOWED_TAGS: ["p", "ul", "li", "b", "i", "h3", "h4", "img"],
          ALLOWED_ATTR: ["src", "alt", "style"],
        });
        setSanitizedSteps(safeSteps);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDetails();
  }, [name]);

  const topicImage = topicFromState?.image || fitnessDetails?.image;
  const topicDescription =
    topicFromState?.description || fitnessDetails?.description;

  if (loading)
    return (
      <div className="text-center my-5">
        <Spinner animation="border" />
        <p>Generating details for {name}...</p>
      </div>
    );

  if (error)
    return (
      <Container className="py-5 text-center">
        <Alert variant="danger">{error}</Alert>
        <Button variant="secondary" onClick={() => navigate(-1)}>
          Go Back
        </Button>
      </Container>
    );

  if (!fitnessDetails)
    return (
      <Container className="py-5 text-center text-danger">
        Error: No details found.
        <Button className="ms-2" onClick={() => navigate(-1)}>
          Go Back
        </Button>
      </Container>
    );

  return (
    <>
      <NavBar />
      <Container fluid className="mt-4">
        <Row>
          {/* Main Content */}
          <Col lg={9}>
            <h2 className="fw-bold">{name}</h2>
            {topicDescription && (
              <p className="text-muted">{topicDescription}</p>
            )}
            <hr />

            {/* History */}
            {fitnessDetails.history && (
              <Card className="border-0 mb-4">
                <Card.Body>
                  <Card.Title>History</Card.Title>
                  <Card.Text>{fitnessDetails.history}</Card.Text>
                </Card.Body>
              </Card>
            )}

            {/* Image + Steps side by side */}
            {(topicImage ||
              fitnessDetails.steps?.length > 0 ||
              sanitizedSteps) && (
              <Row className="p-2 align-items-start mb-4">
                {/* Left: Image */}
                <Col xs={12} md={6} className="mb-3 mb-md-0 text-center">
                  {topicImage && (
                    <img
                      src={topicImage}
                      alt={name}
                      className="img-fluid rounded shadow-sm"
                      style={{
                        maxHeight: "400px",
                        objectFit: "cover",
                        width: "100%",
                      }}
                    />
                  )}
                </Col>

                {/* Right: Steps */}
                <Col xs={12} md={6}>
                  {(fitnessDetails.steps?.length > 0 || sanitizedSteps) && (
                    <Card className="border-0 h-100">
                      <Card.Body>
                        <Card.Title>Steps</Card.Title>
                        {sanitizedSteps ? (
                          <div
                            className="text-secondary-emphasis overflow-auto"
                            style={{ maxHeight: "400px", paddingRight: "10px" }}
                            dangerouslySetInnerHTML={{ __html: sanitizedSteps }}
                          />
                        ) : (
                          <ul>
                            {fitnessDetails.steps.map((step, idx) => (
                              <li key={idx}>{step}</li>
                            ))}
                          </ul>
                        )}
                      </Card.Body>
                    </Card>
                  )}
                </Col>
              </Row>
            )}

            {/* Benefits */}
            {fitnessDetails.benefits && (
              <Card className="border-0 mb-4">
                <Card.Body>
                  <Card.Title>Benefits</Card.Title>
                  <Card.Text>{fitnessDetails.benefits}</Card.Text>
                </Card.Body>
              </Card>
            )}

            {/* Tips */}
            {fitnessDetails.tips && (
              <Card className="border-0 mb-4">
                <Card.Body>
                  <Card.Title>Tips</Card.Title>
                  <Card.Text>{fitnessDetails.tips}</Card.Text>
                </Card.Body>
              </Card>
            )}
          </Col>

          {/* Right Sidebar (Ads) */}
          <Col lg={3}>
            <h6 style={{ fontSize: "11px" }}>ADVERTISEMENT</h6>
            <img
              src="https://s0.2mdn.net/simgad/6463644956967963792"
              alt="Advertisement"
              height={"250px"}
              width={"300px"}
              className="mb-2"
            />
            <img
              src="https://s0.2mdn.net/simgad/6463644956967963792"
              alt="Advertisement"
              height={"250px"}
              width={"300px"}
            />
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default FitnessDetails;
